import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { TESTIMONIALS } from "@/data/content";

export const TestimonialWall = () => {
    return (
        <section
            id="testimonials"
            className="relative py-24 lg:py-32 overflow-hidden bg-[hsl(var(--bg-2))]/60"
            aria-labelledby="testimonials-heading"
        >
            <div className="absolute inset-0 dot-grid-fine opacity-40 pointer-events-none" />
            <div className="mx-auto max-w-7xl container-px relative">
                <SectionHeading
                    eyebrow="Testimonials"
                    title={
                        <>
                            Voices from operators,
                            <br className="hidden md:block" />
                            founders, and partners.
                        </>
                    }
                    subtitle="Insight-rich reflections from clients building with IdeaClap."
                    className="mb-12"
                />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            initial={{ opacity: 0, y: 14 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-10% 0px" }}
                            transition={{
                                duration: 0.5,
                                delay: i * 0.05,
                                ease: [0.16, 1, 0.3, 1],
                            }}
                            data-testid="testimonial-card"
                            className="relative rounded-2xl border border-black/[0.07] bg-white p-6 lg:p-7 shadow-soft"
                        >
                            <span className="font-display text-5xl leading-none text-[hsl(var(--gold))] absolute top-3 left-5 select-none">
                                “
                            </span>
                            <blockquote className="font-display text-[18.5px] leading-[1.45] text-[hsl(var(--text))] pt-3">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-5 pt-4 border-t border-black/[0.08] flex items-center justify-between text-[13px]">
                                <span className="text-[hsl(var(--text))]">{t.name}</span>
                                <span className="text-[hsl(var(--text-subtle))] font-mono uppercase tracking-[0.18em] text-[11px]">
                                    {t.title}
                                </span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialWall;
